import { render, staticRenderFns } from "./legr_list.vue?vue&type=template&id=390a867d&scoped=true"
import script from "./legr_list.vue?vue&type=script&lang=js"
export * from "./legr_list.vue?vue&type=script&lang=js"
import style0 from "./legr_list.vue?vue&type=style&index=0&id=390a867d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../home/zarzar/Documents/public-solution/bis-office/web/auftragsbuch/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390a867d",
  null
  
)

export default component.exports